import React from 'react'
import {
    NavBar,Tabs,SearchBar,Card,Grid,InfiniteScroll,DotLoading,Footer,Input
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import { SmileOutline} from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../ShoppingCart/index.css'
import { useNavigate } from 'react-router-dom';
import { environment } from '../../service/baseUrl';

import {
    PostNNShoppingOrders,GetDataDictionarysByCode
} from '../../service/service';


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            userInfo: null,
            tabTypes: [],
            tabIdx: 0,

            shoppings: [],
            totalCount: 0,
            page: 0,
            pageSize: 10,
            hasMore: true,
            loading: false,
            initialLoading: false,

            OrderNum:"",

            display: "none"
        };
    }

    componentDidMount() {
        var that = this;
        var user = localStorage.getItem("user");
        
        if (user == null || user == undefined) {

        } else {
            this.setState({
                userInfo: JSON.parse(user),
                initialLoading: true
            }, () => {
                this.loadPosts();
            })

        }

        
        GetDataDictionarysByCode("CPZBLB").then(res => {
            if (res.success) {
                var arry = [{ text: "全部", id: "0" }];
                res.result.map((item) => {
                    // if (item.displayName != "河灯" && item.displayName != "孔明灯") {
                    //     if (index == 0) {
                    //         typeTab = item.id;
                    //     }
                    // }
                    arry.push({ text: item.displayName, id: item.id })
                })
                that.setState({
                    tabTypes: arry,
                })
            }
        })

    }


    loadPosts = async () => {
        var that = this;
        const { page, pageSize, tabIdx, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            OpenId: this.state.userInfo.openId,
            OrderNum:this.state.OrderNum,
            PayState: 2,
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
            ProductTypeId: tabIdx == 0 ? undefined : tabIdx
        };

        try {
            PostNNShoppingOrders(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    
                    newPosts.map(item => {
                        var str = "";
                        switch (item.productTypeId) {
                            case 487:
                                str = "种 植";
                                break;
                            case 489:
                                str = "领 养";
                                break;
                            case 490:
                                str = "建 设";
                                break;
                            case 499:
                                str = "敬 献";
                                break;
                            case 516:
                                str = "空间装饰";
                                break;
                            case 497:
                            case 498:
                                str = "点 亮";
                                break;
                            default:
                                str = "装 饰";
                                break;
                        }
                        item.type = str;

                        if (item.productImgUrl != null) {
                            var name = item.productImgUrl.split('/').pop()
                            item.productImgUrl = environment.apiEndpoint + "/NNFiles/Img/" + name;
                        }
                    })
                    
                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;

                    that.setState({
                        shoppings: [...this.state.shoppings, ...newPosts],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        loading: false
                    });
                }
            })
        } catch (error) {
            console.error('加载留言失败:', error);
            this.setState({
                initialLoading: false, loading: false
            });
        }
    }


    submitForm = () => {
        
    }
    


    render() {


        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/my', { replace: true }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4' }}>
                    我的订单
                </NavBar>


                <div style={{
                    height: "85%", backgroundColor: "rgb(227 227 227)", paddingTop: "5%"
                }}>

                    <div style={{ padding: "0px 10px 5px" }}>
                        
                        <div style={{
                                // backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-16.png')"
                                // , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", 
                                height: "38px", width: "96%", marginLeft: "2%",borderRadius:"20px",backgroundColor:"#fff"
                            }}>
                                <Grid columns={4} gap={8}>
                                    <Grid.Item span={3}>
                                        <Input
                                            value={this.state.OrderNum}
                                            onChange={(value) => {
                                                this.setState({
                                                    OrderNum:value
                                                })
                                            }}
                                            placeholder="请输入订单号"
                                            style={{
                                                '--background': 'transparent',
                                                '--border': 'none',
                                                '--placeholder-color': '#999',
                                                '--text-align': 'left',
                                                '--font-size': '14px',
                                                paddingLeft: '12px',
                                                height: '38px',
                                                paddingLeft: '15px',
                                            }}
                                        />
                                    </Grid.Item>
                                    <Grid.Item span={1}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-17.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , lineHeight: "38px", textAlign: "center", fontSize: "15px", color: "#fff"
                                        }} onClick={()=>{
                                            this.setState({
                                                shoppings: [],
                                                page: 0,
                                                hasMore: true
                                            },()=>{
                                                this.loadPosts();
                                            });
                                        }}>
                                            搜 索
                                </div>
                                    </Grid.Item>
                                </Grid>
                            </div>

                    </div>

                    <Tabs defaultActiveKey={this.state.tabIdx} style={{ marginBottom: "10px" }}
                        onChange={(key) => {
                            this.setState({
                                tabIdx: key,
                                shoppings: [],
                                page: 0,
                                hasMore: true
                            },()=>{
                                this.loadPosts();
                            });

                        }}>
                        {
                            this.state.tabTypes.map(item => {
                                return (<Tabs.Tab title={item.text} key={item.id}></Tabs.Tab>)
                            })
                        }
                    </Tabs>

                    <div style={{ width: "94%", marginLeft: "3%",overflowY: "scroll", height: "95%" }} >

                        {
                            this.state.shoppings.map(item => {
                                return (<div style={{ marginBottom: "5%" }}>
                                    <Card>

                                        <div style={{ color: "rgb(123 123 123)", fontSize: "13px" }}>
                                            <Grid columns={7} gap={8} style={{ marginTop: "5px", alignItems: "center" }}>
                                                {/* 第一个 Grid.Item */}
                                                <Grid.Item span={2}>
                                                    <div style={{
                                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/12-11.png')",
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundSize: "100% 100%",
                                                        height: "30px",
                                                        width: "85%",
                                                        textAlign: "center",
                                                        fontSize: "14px",
                                                        lineHeight: "30px", // 行高与高度相同，确保文字垂直居中
                                                        fontWeight: "600",
                                                        color: "#fff",
                                                        display: "flex", // 使用 Flexbox 布局
                                                        alignItems: "center", // 垂直居中
                                                        justifyContent: "center" // 水平居中
                                                    }}>
                                                        {item.type}
            </div>
                                                </Grid.Item>

                                                {/* 第二个 Grid.Item */}
                                                <Grid.Item span={3}>
                                                    <div style={{
                                                        width: "100%",
                                                        height: "100%", // 确保容器高度与父容器一致
                                                        display: "flex", // 使用 Flexbox 布局
                                                        alignItems: "center", // 垂直居中
                                                        justifyContent: "center" // 水平居中
                                                    }}>
                                                        <span>
                                                            订单号：{item.orderNum}
                </span>
                                                    </div>
                                                </Grid.Item>

                                                {/* 第三个 Grid.Item */}
                                                <Grid.Item span={2}>
                                                    <div style={{
                                                        height: "100%", // 确保容器高度与父容器一致
                                                        display: "flex", // 使用 Flexbox 布局
                                                        alignItems: "center", // 垂直居中
                                                        marginRight: "5%",
                                                        justifyContent: "flex-end" // 水平居中
                                                    }}>
                                                        <span>
                                                            已完成
                </span>
                                                    </div>
                                                </Grid.Item>
                                            </Grid>
                                        </div>


                                        <div style={{
                                            borderBottom: "solid 2px #e5e5e5", width: "98%",
                                            marginLeft: "1%", marginTop: "10px"
                                        }}></div>

                                        <div style={{
                                            color: "rgb(123 123 123)", fontSize: "13px", marginBottom: "8px"
                                        }}>
                                            <Grid columns={22} gap={8} style={{ marginTop: "12px" }}>

                                                <Grid.Item span={1}>
                                                </Grid.Item>
                                                {
                                                    item.productTypeId != 516 ?
                                                        <>
                                                            <Grid.Item span={7}>
                                                                <div style={{
                                                                    fontSize: "17px", fontWeight: "600", color: "#000"
                                                                }}>
                                                                    {item.productName}
                                                                </div>
                                                            </Grid.Item>
                                                            <Grid.Item span={7}>
                                                                <div>
                                                                    展示时长：{item.endDateTypeName}
                                                                </div>
                                                            </Grid.Item>
                                                        </> :
                                                        <Grid.Item span={14}>
                                                            <div style={{
                                                                fontSize: "17px", fontWeight: "600", color: "#000"
                                                            }}>
                                                                {item.productName}
                                                            </div>
                                                        </Grid.Item>
                                                }
                                                <Grid.Item span={7}>
                                                    <div style={{
                                                        textAlign: "end", marginRight: "8%", fontSize: "17px", fontWeight: "600",
                                                        color: "#000"
                                                    }}>
                                                        ￥{item.productPayPrice}
</div>
                                                    <div style={{ textAlign: "end", marginRight: "8%" }}>
                                                        {
                                                            item.creationTime ?
                                                                dayjs(item.creationTime).format('YYYY-MM-DD') : ''
                                                        }
</div>
                                                </Grid.Item>

                                            </Grid>
                                        </div>

                                    </Card>
                                </div>)
                            })
                        }


                        {
                            this.state.page != 0 ?
                                <InfiniteScroll
                                    loadMore={this.loadPosts}
                                    hasMore={this.state.hasMore}
                                    threshold={50}
                                    initialLoad={false}
                                    style={{marginBottom: "20%",paddingTop: "10px"}}
                                >
                                    {this.state.loading && (
                                        <div style={{ textAlign: 'center' }}>
                                            <DotLoading color="primary" />
                                            <span style={{ marginLeft: 8 }}>加载中...</span>
                                        </div>
                                    )}
                                    {!this.state.hasMore && (
                                        <div style={{ textAlign: 'center', color: 'rgb(0 0 0)' }}>
                                            没有更多消费记录了
                                </div>
                                    )}
                                </InfiniteScroll> : null
                        }


                    </div>

                </div>



                <BottomMenu  position="absolute" selectKey="my" />

            </div>
        )
    }
}

export default withNavigate(Index);